const key = 'lkn-monitor-settings'

const save = function (params) {
  window.localStorage.setItem(key, JSON.stringify(params))
}

const DEFAULT_PARAMS = {
  // 1厘米对应的像素
  cm: 90,
  // 纸速
  speed: 2,
  // 正常范围值
  normalRange: [110, 160],
  // 床位数量
  bedMode: 4,
  // fhr范围标准：1、2
  fhrRange: 1,
  // 报警设置
  alarm: {
    fhrRange: false
  }
}

const get = function () {
  let params = window.localStorage.getItem(key)
  if (params) {
    params = JSON.parse(params)
    return {
      cm: params.cm || DEFAULT_PARAMS.cm,
      speed: params.speed || DEFAULT_PARAMS.speed,
      normalRange: params.normalRange || DEFAULT_PARAMS.normalRange,
      bedMode: params.bedMode || DEFAULT_PARAMS.bedMode,
      fhrRange: params.fhrRange || DEFAULT_PARAMS.fhrRange,
      alarm: params.alarm || DEFAULT_PARAMS.alarm
    }
  } else {
    params = JSON.parse(JSON.stringify(DEFAULT_PARAMS))
    save(params)
    return params
  }
}

export default {
  save,
  get
}
